import React from 'react';
import { STATUS_ICONS_NAMES } from '../../constants/STATUS_ICONS';
import SalesIcon from '../components/Icons/TicketType/Sales';
import PreorderIcon from '../components/Icons/TicketType/Preorder';
import ElectronicIcon from '../components/Icons/TicketType/Electronic';
import SalesLandingIcon from '../components/Icons/TicketType/SalesLandingIcon';
import PreorderLandingIcon from '../components/Icons/TicketType/PreorderLandingIcon';
import ElectronicLandingIcon from '../components/Icons/TicketType/ElectronicLandingIcon';
import PaperLandingIcon from '../components/Icons/TicketType/PaperLandingIcon';
import PaperIcon from '../components/Icons/TicketType/Paper';

export const getStatusIcon = (status: string, isLanding: boolean) => {
  if (status === STATUS_ICONS_NAMES.AVAILABLE) {
    return isLanding ? <SalesLandingIcon /> : <SalesIcon />;
  }
  if (status === STATUS_ICONS_NAMES.PREORDER) {
    return isLanding ? <PreorderLandingIcon /> : <PreorderIcon />;
  }
};
export const getTicketTypeIcon = (ticketType: number, isLanding: boolean) => {
  if (ticketType === 1) {
    return isLanding ? <ElectronicLandingIcon /> : <ElectronicIcon />;
  }
  if (ticketType === 2) {
    return isLanding ? <PaperLandingIcon /> : <PaperIcon />;
  }
};
